export interface ChannelLoadingState {
  isLiveChatLoading: boolean;
  isVoiceChatLoading: boolean;
}

export interface SetLoadingPayload {
  channel: 'chat' | 'voice';
  loading: boolean;
}

const state: ChannelLoadingState = {
  isLiveChatLoading: false,
  isVoiceChatLoading: false,
};

const mutations = {
  setChannelLoading(state: ChannelLoadingState, payload: SetLoadingPayload) {
    if (payload.channel === 'chat') {
      state.isLiveChatLoading = payload.loading;
    }
    if (payload.channel === 'voice') {
      state.isVoiceChatLoading = payload.loading;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
};
